import useTranslation from "../../hooks/useTranslation";
import { TrainingModuleOption } from "../../types/actionPlan";
import { TrainingModuleInfo } from "../TrainingModuleInfo/TrainingModuleInfo";
import { DatePicker } from "../ui/Input/DatePicker";
import { Typography } from "../ui/Typography/Typography";
import "./ActionPlanTrainingWizard.scss";

interface ModuleScheduleStepProps {
  selectedModules: TrainingModuleOption[];
  onDateChange: (moduleId: string, date: Date) => void;
}

export const ModuleScheduleStep = ({
  selectedModules,
  onDateChange,
}: ModuleScheduleStepProps) => {
  const { t } = useTranslation("actionPlanPage");

  const handleDateChange = (moduleId: string, date: Date | null) => {
    if (!date) return;
    onDateChange(moduleId, date);
  };

  const getDateValue = (module: TrainingModuleOption): Date | null => {
    return module.scheduledDate ? new Date(module.scheduledDate) : null;
  };

  return (
    <div className="ModuleScheduleStep">
      {selectedModules.map((module) => (
        <div
          key={module.trainingModule.referenceId}
          className="ModuleScheduleStep__item"
        >
          <TrainingModuleInfo trainingModule={module.trainingModule} />
          <Typography
            className="ModuleScheduleStep__item__datePickerLabel"
            desktop="body2"
            color="secondary"
            weight="bold"
          >
            {t("addModules.scheduleModule.datePickerLabel")}
          </Typography>
          <DatePicker
            value={getDateValue(module)}
            minDate={new Date()}
            onChange={(date) =>
              handleDateChange(module.trainingModule.referenceId, date)
            }
            dataTestId={`module-date-${module.trainingModule.referenceId}`}
          />
        </div>
      ))}
    </div>
  );
};
